import { XMarkIcon } from "@heroicons/react/24/solid";
import { AuthForm, FormKind } from "@web/components/AuthForm";
import { useAppContext } from "@web/route-services/root/AppContext";

interface AuthModalProps {
  formKind: FormKind;
}

export function AuthModal({ formKind }: AuthModalProps) {
  const { closeModal, isDesktopScreen } = useAppContext();

  return (
    <div className="relative">
      {isDesktopScreen && (
        <button
          className="absolute right-3 top-3"
          onClick={() => {
            closeModal();
          }}
        >
          <XMarkIcon className="text-tx-secondary size-5" />
        </button>
      )}
      <AuthForm formKind={formKind} />
    </div>
  );
}
